var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import { fuzzyFilter } from '../../../../utils';
import { getSessionSearch, setSessionSearch } from '../utils';
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.clearInput = function () {
            var node = _this.inputRef.current;
            if (node !== null) {
                node.value = '';
            }
        };
        _this.handleChange = function (query, queryHistory) {
            if (query === '') {
                _this.clearInput();
            }
            if (_this.props.sessionKey !== undefined) {
                setSessionSearch(_this.props.sessionKey, queryHistory);
            }
            if (query !== _this.state.query) {
                _this.setState({
                    query: query,
                    queryHistory: queryHistory
                });
            }
        };
        _this.applyFilter = function (query) {
            var filtered = query.trim() !== ''
                ? fuzzyFilter(query, _this.props.defaultField, _this.props.data)
                : _this.props.data;
            _this.setState({
                query: query,
                filtered: filtered
            }, function () {
                _this.props.onChange(_this.state);
            });
        };
        var queryHistory = props.initialHistory;
        if (props.sessionKey !== undefined) {
            queryHistory = (_a = getSessionSearch(props.sessionKey)) !== null && _a !== void 0 ? _a : props.initialHistory;
        }
        _this.state = {
            query: '',
            filtered: props.data,
            queryHistory: queryHistory
        };
        _this.inputRef = React.createRef();
        _this.updateFilteredData = debounce(_this.applyFilter, props.delay);
        return _this;
    }
    Filter.prototype.componentDidMount = function () {
        var _a = this.props, data = _a.data, initial = _a.initial;
        /* eslint-disable-next-line */
        if (data && initial !== undefined) {
            // Call non-debounced method on mount to avoid full-result flash
            this.applyFilter(initial);
            var node = this.inputRef.current;
            if (node !== null) {
                node.value = initial;
            }
        }
    };
    Filter.prototype.componentDidUpdate = function (prevProps, _a) {
        var query = _a.query;
        if (prevProps.data !== this.props.data) {
            // Apply current search to new data
            this.applyFilter(this.state.query);
        }
        if (query !== this.state.query) {
            this.updateFilteredData(this.state.query);
        }
    };
    Filter.prototype.componentWillUnmount = function () {
        // Cancel debounce
        this.updateFilteredData.cancel();
    };
    Filter.prototype.render = function () {
        return this.props.children({
            onChange: this.handleChange,
            query: this.state.query,
            queryHistory: this.state.queryHistory,
            rawData: this.props.data,
            rawLength: this.props.data.length,
            data: this.state.filtered,
            dataLength: this.state.filtered.length,
            inputRef: this.inputRef
        });
    };
    Filter.defaultProps = {
        onChange: undefined,
        saveSearch: undefined,
        delay: 0
    };
    return Filter;
}(Component));
export { Filter };
//# sourceMappingURL=Filter.js.map